import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "apt-favorite",
  class: "apt-favorite-wrapper"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "관심 아파트"),
  /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "등록한 아파트의 면적대별 거래 추이와 최근 실거래를 확인합니다")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "favorite-tabs"
}
const _hoisted_4 = ["onDragstart", "onDragenter", "onDrop", "onClick"]
const _hoisted_5 = { class: "tab-order" }
const _hoisted_6 = { class: "tab-name" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "empty-icon" }, "🏠", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "등록된 관심 아파트가 없습니다.", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "empty-sub" }, "아파트 실거래가 검색에서 관심 아파트를 추가해 보세요.", -1)
const _hoisted_12 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 2,
  class: "loading-state"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "불러오는 중...", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 3,
  class: "favorite-detail"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PeriodSelector = _resolveComponent("PeriodSelector")!
  const _component_FavoriteChartItem = _resolveComponent("FavoriteChartItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.favorites.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.favorites, (fav, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: fav.id,
              class: _normalizeClass(["tab-item", { active: _ctx.selectedIdx === idx }]),
              draggable: "true",
              onDragstart: ($event: any) => (_ctx.onDragStart(idx, $event)),
              onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
              onDragenter: _withModifiers(($event: any) => (_ctx.onDragEnter(idx)), ["prevent"]),
              onDrop: ($event: any) => (_ctx.onDrop(idx)),
              onClick: ($event: any) => (_ctx.selectTab(idx))
            }, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(idx + 1), 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(fav.aptNm), 1),
              _createElementVNode("button", {
                class: "tab-delete-btn",
                onClick: _withModifiers(($event: any) => (_ctx.onDeleteFavorite(fav, idx)), ["stop"]),
                title: "삭제"
              }, "×", 8, _hoisted_7)
            ], 42, _hoisted_4))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.favorites.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_12))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
      : _createCommentVNode("", true),
    (_ctx.selectedFavorite && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_component_PeriodSelector, {
            selected: _ctx.period,
            onChange: _ctx.onChangePeriod
          }, null, 8, ["selected", "onChange"]),
          (_openBlock(), _createBlock(_component_FavoriteChartItem, {
            key: _ctx.selectedFavorite.id + '-' + _ctx.period,
            apt: _ctx.selectedFavorite,
            period: _ctx.period
          }, null, 8, ["apt", "period"]))
        ]))
      : _createCommentVNode("", true)
  ]))
}